import React from 'react';
import { Box, Link, List, ListItem, ListItemText, Stack, Typography } from '@mui/material';
import { QRCodeCanvas } from 'qrcode.react';

import { useLanguage } from '~/hooks/language';

interface Props {
  isPending: boolean;
  qrCodeLink: string;
}

export const SetupTwoFactorQrCode: React.FC<Props> = ({ qrCodeLink }) => {
  const { translate } = useLanguage('ua');

  return (
    <Stack spacing={3} mt={4}>
      {/* QR */}
      <Box
        sx={{
          padding: '10px 10px 5px 10px',
          borderRadius: '10px',
          border: '1px solid',
          borderColor: 'divider',
          width: 'fit-content',
        }}
      >
        <QRCodeCanvas value={qrCodeLink} size={120} />
      </Box>

      {/* Instructions */}
      <Box width="100%" sx={{ mt: '50px' }} mt={150}>
        <Typography variant="body2" fontWeight={600}>
          {translate('invite.setupTwoFactorAuth.authApp.instructionsTitle')}
        </Typography>

        <List dense sx={{ pl: 2, listStyleType: 'unset' }}>
          <ListItem sx={{ display: 'list-item', p: 0 }}>
            <ListItemText primary={translate('invite.setupTwoFactorAuth.authApp.steps.one')} />
          </ListItem>
          <ListItem sx={{ display: 'list-item', p: 0 }}>
            <ListItemText primary={translate('invite.setupTwoFactorAuth.authApp.steps.two')} />
          </ListItem>
          <ListItem sx={{ display: 'list-item', p: 0 }}>
            <ListItemText primary={translate('invite.setupTwoFactorAuth.authApp.steps.three')} />
          </ListItem>
        </List>
      </Box>

      {/* Auth apps */}
      <Stack direction="row" spacing={1} width="100%">
        <Link
          href="https://support.google.com/accounts/answer/1066447?hl=en&co=GENIE.Platform%3DAndroid&oco=0"
          target="_blank"
          rel="noreferrer"
          underline="none"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            p: 1,
            borderRadius: 1,
            border: '1px solid',
            borderColor: 'divider',
            '&:hover': { bgcolor: 'action.hover' },
          }}
        >
          <Box component="img" src="/google-auth.svg" alt="Google Authenticator" width={20} height={20} />
          <Typography variant="body2">{translate('invite.setupTwoFactorAuth.authApp.googleAuthLabel')}</Typography>
        </Link>

        <Link
          href="https://www.microsoft.com/en-us/security/mobile-authenticator-app"
          target="_blank"
          rel="noreferrer"
          underline="none"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            p: 1,
            borderRadius: 1,
            border: '1px solid',
            borderColor: 'divider',
            '&:hover': { bgcolor: 'action.hover' },
          }}
        >
          <Box component="img" src="/microsoft-auth.svg" alt="Microsoft Authenticator" width={20} height={20} />
          <Typography variant="body2">{translate('invite.setupTwoFactorAuth.authApp.microsoftAuthLabel')}</Typography>
        </Link>
      </Stack>
    </Stack>
  );
};
